import React, { useState, useEffect } from 'react'
import { Row, Col, Table, Button, Form, Modal } from "react-bootstrap";
import useStateRef from 'react-usestateref';
import { Link,useNavigate } from "react-router-dom";
import Card from "../../../../../components/Card";
import swal from 'sweetalert';
//import apiPath from "../../../../../config/apipath";
import apiService from "../../../../../provider/apiService";

import "../../../../App.css";


const TableData = () => {

  const [DtDetTable, setDtDetTable, DtDetTableRef]=useStateRef([]);
  let DetTable=[];

  const [DtStDetTable, setDtStDetTable, DtStDetTableRef]=useStateRef([]);
  let StDetTable=[];

 const [SaveButtonText, setSaveButtonText] = useState("Save");
 
 
  useEffect(() => {

    
    sessionStorage.getItem("BranchIssue_EditElg")==='true' ?  setDisabled(''):  setDisabled('disabled');   
	
	
   if(sessionStorage.getItem("BranchIssue_Action")=="Add")
   {
	    setSaveButtonText("Save");
      
     
    document.getElementById("txtIssueNo").value="{Auto}";
    document.getElementById("txtIssueDate").value=(new Date()).toISOString().substring(0,10);
   
    

   }
   else if(sessionStorage.getItem("BranchIssue_Action")=="Edit")
   {
	   setSaveButtonText("Update");
	   Display(sessionStorage.getItem("BranchIssue_EditId"));
   }
   else if(sessionStorage.getItem("BranchIssue_Action")=="Delete")
   {
	   setSaveButtonText("Delete");
	   Display(sessionStorage.getItem("BranchIssue_EditId"));
   }
	
   ControlSettings();

   innitialSetValue();
   

  }, []);
  
  async function setCheck(value,id)
  {

    
    let i=0;

    DetTable=DtDetTable;
   
    for(i=0;i<DetTable.length;i++)
    {
      if(id==DetTable[i].GrnNo)
      {
        DetTable[i].checked=value;
        
      } 
     
  }
  setDtDetTable(DetTable);

  setlocaltime(new Date());


}


  function innitialSetValue() {


  getLookup();
  getPending();

  }


  const [show1, setShow1] = useState(false);
  const [sho, setSho] = useState(false);
  const [show, setShow] = useState(false);
  const handleClose1 = () => setShow1(false);
  const handleShow1 = () => setShow1(true);
 
   const [TMshow1, setTMShow1] = useState(false);
   const TMhandleClose1 = () => setTMShow1(false);
   const TMhandleShow1 = () => setTMShow1(true);
    
   const [localtime,setlocaltime] =useState(new Date());
   const [btndisabled, setDisabled] = useState('disabled');

  const [DtParty, setDtParty]=useState([]);
  const [DtBranch, setDtBranch]=useState([]);
  const [DtOrderNo, setDtOrderNo]=useState([]);
  const [DtProduct, setDtProduct]=useState([]);
  const [DtSubProduct, setDtSubProduct]=useState([]);
  const [ProdName, setProdName]=useState([]);
  const [SubProdName, setSubProdName]=useState([]);
  const [DtPurity, setDtPurity]=useState([]);
  const [DtRecMode, setDtRecMode]=useState([]);
  
  const [DtStProduct, setDtStProduct]=useState([]);
  const [DtStSubProduct, setDtStSubProduct]=useState([]);
  const [StProdName, setStProdName]=useState([]);
  const [StSubProdName, setStSubProdName]=useState([]);
  const [DtStRecMode, setDtStRecMode]=useState([]);
 

  const [AccCode, setAccCode, AccCodeRef] = useStateRef();
  const [OrderNo, setOrderNo, OrderNoRef] = useStateRef();
  const [BranchCode, setBranchCode, BranchCodeRef] = useStateRef();

 
  const [MetalCatRec, setMetalCatRec, MetalCatRecRef] = useStateRef();
 
 async function OpenStoneScreen()
 {
 

  let HeadID=document.getElementById("txtId").value;

  //setDtStDetTable([]);

  //StDetTable=[];

  DetTable=DtDetTable;
       
       var cnt = 0;
       var i=0;
        try {
            cnt = DetTable.length;
        }
        catch (err) {  
            cnt = 0;
        }
let isFound=false;

        for (i = 0; i < cnt; i++)
        {
            if ((DetTable[i].ID == HeadID))
            {
              setDtStDetTable(DetTable[i].StoneDetails);
              StDetTable=DetTable[i].StoneDetails;

              isFound=true;
              break;
            }
        }
        if (isFound==false)
        {
          // setDtStDetTable([]);
          //StDetTable=[];
        }

        setTMShow1(true);
 }

  async function CloseStoneScreen()
  {


    let HeadID=document.getElementById("txtId").value;

      StDetTable=DtStDetTable;
       
        var cnt = 0;
        try {
            cnt = StDetTable.length;
        }
        catch (err) {
            cnt = 0;
        }
     
      let i=0;
      document.getElementById("txtStoneAmt").value="0";
      document.getElementById("txtStonePcs").value="0";
           
        for (i = 0; i < cnt; i++)
        {
           
              document.getElementById("txtStoneAmt").value=val(val( document.getElementById("txtStoneAmt").value)+val(StDetTable[i].StTotalAmt)).toFixed(2);
              document.getElementById("txtStonePcs").value=val(val( document.getElementById("txtStonePcs").value)+val(StDetTable[i].Pcs)).toFixed(2);
            
        }

       



    setTMShow1(false);
  }


 async function gridAdd () {




      let slno=document.getElementById("txtId").value;
      let ProdName=document.getElementById("txtProductName").value;
      let SubProdName=document.getElementById("txtSubProdName").value;
      
      let Purity1=document.getElementById("txtPurity1").value;
      let Purity=document.getElementById("txtPurity").value;
      let RecMode=document.getElementById("txtRecMode").value;
      let Pcs=val(document.getElementById("txtPcs").value);
      let PcsRate=val(document.getElementById("txtPcsRate").value);
      let GrossWt=val(document.getElementById("txtGrossWt").value);
      let LessWt=val(document.getElementById("txtLessWt").value);
     
      
      let NetWt=val(document.getElementById("txtNetWt").value);
      let TotalWt=val(document.getElementById("txtTotalWt").value);
      let WasteP=val(document.getElementById("txtWasteP").value);
      let WastePgrm=val(document.getElementById("txtWastePgrm").value);
      let MCPgrm=val(document.getElementById("txtMCPgrm").value);
      let Wasteage=val(document.getElementById("txtWasteage").value);
      let MCPPcs=val(document.getElementById("txtMCPPcs").value);
      let MCValue=val(document.getElementById("txtMCValue").value);
      let Touch=val(document.getElementById("txtTouch").value);
      let StoneAmt=val(document.getElementById("txtStoneAmt").value);
      let StonePcs=val(document.getElementById("txtStonePcs").value);
      let OtherCharges=val(document.getElementById("txtOtherCharges").value);
      let HallMark=val(document.getElementById("txtHallMark").value);
      let PureWt=val(document.getElementById("txtPureWt").value);
      let TotalAmt=val(document.getElementById("txtTotalAmt").value);
      let PcsAmount=val(document.getElementById("txtPcsAmt").value);
      let OrderNo1=(document.getElementById("txtOrderNo1").value);
   

      


if ((ProdName.length>0)&&(SubProdName.length>0)&&(Pcs>0))

{
        DetTable=DtDetTable;


        var cnt = 0;
        try
        {
            cnt = DetTable.length;
           
        }
        catch(err)
        {
            cnt=0;
        }
    
  

        var found = false;
        var i=0;

        for (i = 0; i < cnt; i++) {



            if (DetTable[i].ID == slno) {


              DetTable[i].ProdName=ProdName;
              DetTable[i].SubProdName=SubProdName;
              DetTable[i].Purity1=Purity1;
              DetTable[i].Purity=Purity;
              DetTable[i].RecMode=RecMode;
              DetTable[i].Pcs=Pcs;
              DetTable[i].PcsRate=PcsRate;
              DetTable[i].GrossWt=GrossWt;
              DetTable[i].LessWt=LessWt;
              DetTable[i].NetWt=NetWt;
              DetTable[i].TotalWt=TotalWt;
              DetTable[i].WasteP=WasteP;
              DetTable[i].WastePgrm=WastePgrm;
              DetTable[i].MCPgrm=MCPgrm;
              DetTable[i].Wasteage=Wasteage;
              DetTable[i].MCPPcs=MCPPcs;
              DetTable[i].MCValue=MCValue;
              DetTable[i].Touch=Touch;
              DetTable[i].StoneAmt=StoneAmt;
              DetTable[i].StonePcs=StonePcs;
              DetTable[i].OtherCharges=OtherCharges;
              DetTable[i].HallMark=HallMark;
              DetTable[i].PureWt=PureWt;
              DetTable[i].TotalAmt=TotalAmt;
              DetTable[i].PcsAmount=PcsAmount;
              DetTable[i].OrderNo1=OrderNo1;
              DetTable[i].StoneDetails=DtStDetTable;
             
               
              setDtStDetTable([]);
              StDetTable=[];
              



                found = true;
                break;
            }
            else {


                if ((DetTable[i].ProdName == ProdName) && (DetTable[i].SubProdName == SubProdName) && (parseFloat(DetTable[i].Pcs).toFixed(3) == parseFloat(Pcs).toFixed(3))) {
                    swal({
					  title: "",
					  text: "Already Found",
					  icon: "info",
					  button: "Ok"

						});
	
                    found = true;
                    break;

                }
            }
        }


        if (found == false) {

            var row = {
                "ID": parseInt(cnt) + 1
                , "ProdName":ProdName
                , "SubProdName":SubProdName
                , "Purity1":Purity1
                , "Purity":Purity
                , "RecMode":RecMode
                , "Pcs":Pcs
                , "PcsRate":PcsRate
                , "GrossWt":GrossWt
                , "LessWt":LessWt
                , "NetWt":NetWt
                , "TotalWt":TotalWt
                , "WasteP":WasteP
                , "WastePgrm":WastePgrm
                , "Wasteage":Wasteage
                , "MCPgrm":MCPgrm
                , "MCPPcs":MCPPcs
                , "MCValue":MCValue
                , "Touch":Touch
                , "StoneAmt":StoneAmt
                , "StonePcs":StonePcs
                , "OtherCharges":OtherCharges
                , "HallMark":HallMark
                , "PureWt":PureWt
                , "TotalAmt":TotalAmt
                , "PcsAmount":PcsAmount
                , "OrderNo1":OrderNo1
                , "StoneDetails":DtStDetTable
               
            };
            setDtStDetTable([]);
            StDetTable=[];
            
                DetTable[cnt] = row;

           
               

        }
      
      await setDtDetTable(DetTable);


 


	 
	
}
else
{
	
	swal({
      title: "",
      text: "Fill All Data",
      icon: "info",
      button: "Ok"

    });
	
	
  //alert("Fill All Data");
}

    }

    






function val(value)
{
	value=parseFloat(value);
	if(isNaN(value)==true)
		value=0;
	else
		value=value;
	
	return value;
}



async function ControlSettings()
{

  document.getElementById("txtIssueNo").disabled ='true';
  document.getElementById("txtIssueDate").disabled ='true';
  
  if((sessionStorage.getItem("BranchIssue_Action")=="Edit") || (sessionStorage.getItem("BranchIssue_Action")=="Delete"))
   {
    document.getElementById("txtBranchName").disabled ='true';
   }

 



}

async function Display(EditId){
	  try
    {
     
      let postData = {
        EditId: EditId
    }


  

    const results = await apiService.postCall("branchissue/Display",postData);


   if (results != "-1") {
     
	 let HeadData=results.data.Head;
   let DetailData=results.data.Detail;
   let StoneDetail=results.data.StoneDetail;

  await getLookup();
  


   document.getElementById("txtIssueNo").value =HeadData[0][0].IssueNo;
   document.getElementById("txtIssueDate").value=HeadData[0][0].IssueDate.substring(0,10);
   setBranchCode(HeadData[0][0].BranchCode);

   DetTable=DetailData[0];

  
   var cnt = 0;
   try {
       cnt = DetTable.length;
   }
   catch (err) {
       cnt = 0;
   }

   
   var cnt1 = 0;
   try {
       cnt1 = StoneDetail[0].length;
   }
   catch (err) {
       cnt1 = 0;
   }
  

 let i=0;


   for (i = 0; i < cnt; i++)
   {
      let j=0;

      let xStoneDet=[];

      var rowcnt=0;

    
     
      for(j=0;j<cnt1;j++)
      {

      
       
        if(DetTable[i].ID==StoneDetail[0][j].HeadID)
        {

          var row=StoneDetail[0][j];

          xStoneDet[rowcnt] = row;
          rowcnt=rowcnt+1;
        }
      }

      

      DetTable[i].StoneDetails=xStoneDet;


   }
   
   await setDtDetTable(DetTable);


   }

    
    }
    catch (error) {
      console.log(error);
    }

  }


async function Save(){
	  try
		{
	

let lstitems= document.getElementsByClassName("lstItems");

let i=0;
let idlist=[];
let cnt=0;
for(i=0;i<lstitems.length;i++)
{
  let item=lstitems[i];
  
  if (item.checked==true)
  {
    let r={"GrnNo":item.id};
    idlist[cnt]=r;
    cnt=cnt+1;
  }
}


if (idlist.length==0)
{
	swal({

      title: "",
      text: "Please Enter Details",
      icon: "info",
      button: "Ok"

    });
	
	return;
}	


		 
		let postData = {
			"Action" : sessionStorage.getItem("BranchIssue_Action"),
			"EditId" : sessionStorage.getItem("BranchIssue_EditId"),
      "eBranchCode" : sessionStorage.getItem("BranchCode"),
			"FinMinDate":sessionStorage.getItem("FinMinDate").substring(0,10),
			"FinMaxDate":sessionStorage.getItem("FinMaxDate").substring(0,10),
			"EntryUser":sessionStorage.getItem("EntryUser"),
			"IssueDate": document.getElementById("txtIssueDate").value,
			"BranchCode": document.getElementById("txtBranchName").value,
			"DetTable1": idlist
     
		}

    

   const results = await apiService.postCall("branchissue/Save",postData);


  

   if (results != "-1") {

if(results.errorCode=="8888")
{


  swal({

    title: "Alert",
    text: results.data,
    icon: "info",
    button: "Ok"
    
  }).then(function () {
    
  });

  return;

}  
  if(sessionStorage.getItem("BranchIssue_Action")=="Add")
   {
    swal({

      title: "Success",
      text: "Successfully Add Your Details!",
      icon: "success",
      button: "Ok"

    }).then(function () {
      BackToList();
    });
	
  }

  else if(sessionStorage.getItem("BranchIssue_Action")=="Edit")
   {
    swal({

      title: "Success",
      text: "Successfully Update Your Details!",
      icon: "success",
      button: "Ok"

    }).then(function () {
      BackToList();
    });
	
  }
	 
  else if(sessionStorage.getItem("BranchIssue_Action")=="Delete")
  {
   swal({

     title: "Success",
     text: "Successfully Delete Your Details!",
     icon: "success",
     button: "Ok"

   }).then(function () {
    BackToList();
   });
 
 }
	 
      }
    }
    catch (error) {
      console.log(error);
    }

  }




  async function getPending(){
    try
    {

    const AccCode = document.getElementById("txtBranchName").value;
    
  
  
     
    let postData = {
      BranchCode: AccCode
    }

    
DetTable=[];

await setDtDetTable(DetTable);
    

    const results = await apiService.postCall("branchissue/getPending",postData);

   if (results != "-1") {
      setDtDetTable(results.data[0]);
      }
    }
    catch (error) {
      console.log(error);
    }

  }




  async function getLookup(){
	 try {
		
    let postData=[];


    const results = await apiService.postCall("branchissue/Lookup",postData);

	 if (results != "-1") {

    

      setDtBranch(results.data[0][0]);


      }



    } catch (error) {
      console.log(error);
    }
}

 
  const navigate = useNavigate();
  const BackToList = () => {
    navigate('../dashboard/table/smith/branchissue/list');
  };

  return (
    <>
    <input type="Hidden" id="txtId" />
    <input type="Hidden" id="txtStId" />

      <Row>
        <Card>
          <Card.Header className="d-flex justify-content-between">
            <div className="header-title">
              <h4 className="card-title">Branch Issue Screen</h4>
            </div>
          </Card.Header>
          <Card.Body>
            <div className='container'>
              <div className='container-fluid'>
                <div className='row'>
                  <div className='col-lg-6'>
                    <div className='col-md-12 col-lg-12 col-sm-12 col-xs-12'>
                     
                      <div className='container-fluid py-4 '>
                        <div className='row py-2'>
                          <div className='col-md-6'>
                            <Form.Label>Issue No</Form.Label>
                            <Form.Control type="text" Readonly="Readonly" id="txtIssueNo" placeholder="" />
                          </div>
						  
						  
						              <div className='col-md-6'>
                            <Form.Label>Date</Form.Label>
                            <Form.Control type="date" Readonly="Readonly" id="txtIssueDate" placeholder="" />
                          </div>
						  
						  
                          <div className='col-md-12'>
                            <Form.Label>Branch Name</Form.Label>
                             <select className="form-select" id="txtBranchName" value={BranchCode} onChange={getPending}  disabled={false}>
              								{ 
              								DtBranch.map(
              								(item)=>(
              								<option value={item.Code}>{item.BranchName}</option>
              								)
              								)
              								}
							               </select>
                          </div>

                        

                        </div>
                        
                        
                      </div>

                    </div>

                  </div>
                
                 
                                              
                </div>
              </div>
			  
			  
			    
				
				
			 

                  
              <div className="table-responsive mt-4" >
			 
				
                <Table striped id="basic-table" className="table-striped mb-0" role="grid">
                  <thead>
                    <tr>
                    <th>Grn No</th>
                      <th>Grn Date</th>
                      <th>Party Name</th>   
                      <th>Pcs</th>              
                      <th>Gross Wt</th>
                      
						  
                    </tr>
                  </thead>
                  <tbody>
                  {DtDetTable.map((item) => (
                    <tr>
                     
            <td>
             
              <Form.Check className="me-2">
                                        
                                        <Form.Check.Input type="checkbox" onChange={(e) => setCheck(e.target.checked,item.GrnNo)} checked={item.checked} className="lstItems" id={item.GrnNo} />
                                        
                                        <Form.Check.Label>{item.GrnNo.toUpperCase()}</Form.Check.Label>
                                      </Form.Check>
                                      </td>
                  
                      <td>{item.GrnDate.substring(0,10)}</td>
                      <td>{item.AccDesc}</td>
                      <td>{item.PendingPcs}</td>
                      <td>{item.PendingWt}</td>
                     
		
		
                    </tr>
                      )
                      )
                       }     
                  </tbody>
                </Table>
		
              </div>
              <div className='pt-2' style={{ direction: 'rtl' }} >
                <Form.Group className="form-group">
                  <Button type="button" variant='btn btn-primary' >
                    <i className="btn-inner">
                      <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-printer" viewBox="0 0 16 16">
                        <path d="M2.5 8a.5.5 0 1 0 0-1 .5.5 0 0 0 0 1z" />
                        <path d="M5 1a2 2 0 0 0-2 2v2H2a2 2 0 0 0-2 2v3a2 2 0 0 0 2 2h1v1a2 2 0 0 0 2 2h6a2 2 0 0 0 2-2v-1h1a2 2 0 0 0 2-2V7a2 2 0 0 0-2-2h-1V3a2 2 0 0 0-2-2H5zM4 3a1 1 0 0 1 1-1h6a1 1 0 0 1 1 1v2H4V3zm1 5a2 2 0 0 0-2 2v1H2a1 1 0 0 1-1-1V7a1 1 0 0 1 1-1h12a1 1 0 0 1 1 1v3a1 1 0 0 1-1 1h-1v-1a2 2 0 0 0-2-2H5zm7 2v3a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1v-3a1 1 0 0 1 1-1h6a1 1 0 0 1 1 1z" />
                      </svg>
                    </i>
                    <span>Print</span>
                  </Button>{' '}
                  <Button type="button" variant="btn btn-danger" onClick={BackToList}>cancel</Button> {' '}
                  <Button type="button" variant="btn btn-primary" disabled={btndisabled} onClick={Save}>{SaveButtonText}</Button>
                </Form.Group>
              </div>
            </div>
          </Card.Body>
        </Card>
      </Row >
    </>
  );
};

export default TableData;
